import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const TwitterDevice169: FC<Props> = (props) => (
  <Root viewBox="0 0 145.78 300.88" {...props}>
    <defs>
      <clipPath id="tw16-9_svg__clip-path">
        <path fill="none" d="M6.46 154.31h131.6v88.7H6.46z" />
      </clipPath>
      <style>
        {
          '.tw16-9_svg__cls-3{fill:none}.tw16-9_svg__cls-2{fill:#fff}.tw16-9_svg__cls-3{stroke:#f5f5f5;stroke-miterlimit:10}.tw16-9_svg__cls-4{fill:#9e9e9e}.tw16-9_svg__cls-5{fill:#1ba1f4}.tw16-9_svg__cls-7{fill:#eee}.tw16-9_svg__cls-8{fill:#424242}.tw16-9_svg__cls-9{fill:#f5f5f5}'
        }
      </style>
    </defs>
    <g id="tw16-9_svg__\u30EC\u30A4\u30E4\u30FC_2" data-name="\u30EC\u30A4\u30E4\u30FC 2">
      <g id="tw16-9_svg__\u30EC\u30A4\u30E4\u30FC_1-2" data-name="\u30EC\u30A4\u30E4\u30FC 1">
        <rect width={145.78} height={300.88} rx={21.72} />
        <path
          className="tw16-9_svg__cls-2"
          d="M6.28 39.65h132.07v21.96H6.28zM138.27 39.65v-18A14.31 14.31 0 00124 7.33h-14.16v1.92a7.59 7.59 0 01-7.59 7.59H43.14a7.59 7.59 0 01-7.59-7.59V7.33h-15A14.31 14.31 0 006.28 21.64v18z"
        />
        <path
          className="tw16-9_svg__cls-2"
          d="M6.28 60.24v219a14.31 14.31 0 0014.31 14.31H124a14.31 14.31 0 0014.31-14.31v-219z"
        />
        <rect x={53.71} y={286.02} width={34.73} height={3.52} rx={1.76} />
        <path className="tw16-9_svg__cls-3" d="M6.46 243h131.65M6.46 36.17h131.65" />
        <circle className="tw16-9_svg__cls-4" cx={129.32} cy={272.22} r={4.77} />
        <circle className="tw16-9_svg__cls-4" cx={92.43} cy={272.22} r={4.77} />
        <circle className="tw16-9_svg__cls-4" cx={53.81} cy={272.22} r={4.77} />
        <circle className="tw16-9_svg__cls-5" cx={16.93} cy={272.22} r={4.77} />
        <rect x={13.4} y={249.8} width={116.48} height={11.38} rx={5.69} fill="#e7e7e7" />
        <path className="tw16-9_svg__cls-7" d="M26.67 50.01h21.38v3.94H26.67zM26.68 44h34.36v4.21H26.68z" />
        <circle className="tw16-9_svg__cls-8" cx={16.92} cy={49.87} r={6.55} />
        <circle className="tw16-9_svg__cls-4" cx={32.09} cy={147.51} r={3.3} />
        <circle className="tw16-9_svg__cls-5" cx={67.5} cy={46.81} r={1.73} />
        <path
          className="tw16-9_svg__cls-7"
          d="M29.92 124.19h55.23v4.21H29.92zM29.92 131.54h30.11v4.21H29.92zM36.75 145.51h14.2v4.01h-14.2z"
        />
        <circle className="tw16-9_svg__cls-4" cx={64.07} cy={147.51} r={3.3} />
        <path className="tw16-9_svg__cls-7" d="M68.73 145.51h14.2v4.01h-14.2z" />
        <circle className="tw16-9_svg__cls-4" cx={92.48} cy={147.51} r={3.3} />
        <path className="tw16-9_svg__cls-7" d="M97.14 145.51h14.2v4.01h-14.2z" />
        <rect className="tw16-9_svg__cls-5" x={100.59} y={124.68} width={28.09} height={9.87} rx={2.89} />
        <path className="tw16-9_svg__cls-9" d="M132.16 120.8v18.89H27.87V120.8h104.29m1-1H26.87v20.89h106.29V119.8z" />
        <path className="tw16-9_svg__cls-8" d="M26.92 61.69h106.19v58.85H26.92z" />
        <g clipPath="url(#tw16-9_svg__clip-path)">
          <path className="tw16-9_svg__cls-7" d="M26.67 164.04h21.38v3.94H26.67zM26.68 158.03h34.36v4.21H26.68z" />
          <circle className="tw16-9_svg__cls-8" cx={16.92} cy={163.9} r={6.55} />
          <circle className="tw16-9_svg__cls-4" cx={32.09} cy={261.54} r={3.3} />
          <circle className="tw16-9_svg__cls-5" cx={67.5} cy={160.84} r={1.73} />
          <path
            className="tw16-9_svg__cls-7"
            d="M29.92 238.21h55.23v4.21H29.92zM29.92 245.56h30.11v4.21H29.92zM36.75 259.53h14.2v4.01h-14.2z"
          />
          <circle className="tw16-9_svg__cls-4" cx={64.07} cy={261.54} r={3.3} />
          <path className="tw16-9_svg__cls-7" d="M68.73 259.53h14.2v4.01h-14.2z" />
          <circle className="tw16-9_svg__cls-4" cx={92.48} cy={261.54} r={3.3} />
          <path className="tw16-9_svg__cls-7" d="M97.14 259.53h14.2v4.01h-14.2z" />
          <rect className="tw16-9_svg__cls-5" x={100.59} y={238.71} width={28.09} height={9.87} rx={2.89} />
          <path
            className="tw16-9_svg__cls-9"
            d="M132.16 234.83v18.89H27.87v-18.89h104.29m1-1H26.87v20.89h106.29v-20.89z"
          />
          <path className="tw16-9_svg__cls-8" d="M26.92 175.71h106.19v58.85H26.92z" />
        </g>
      </g>
    </g>
  </Root>
);

const Root = styled('svg')();

export default TwitterDevice169;
